import React, { useState, useEffect, useRef, Fragment } from "react";
import $ from "jquery";
import { connect } from "react-redux";
import {
  getReturnCalculations,
  getReturnPoliciesBasedOnAge,
  getReturnPremiumListBasedOnTerm,
  getReturnTermsBasedOnPolicy,
  setReturnalCalculatorData,
} from "../../actions/Utils";
import { Link } from "react-router-dom";
import LangData from "../common/LangData";
import DateInput from "./DateInput";
// import { axiosNewInstance } from "../../config/Api";

const ReturncalCulatorform = (props) => {
  const initialState = {
    validator: {
      dob: "",
      policy: "",
      term: "",
      premium: "",
      sum_assured: "",
      critical_illness: "",
      critical_sum: "",
      gender: "",
    },
    message: "",
    message_type: "",
    policy: {},
    terms: {},
    premiums: {},
    styleinfo: {
      accidental: "none",
      licterm: "block",
      parentage: "none",
      critical: "none",
      critical_sum: "none",
      gender: "none",
    },
    calculation: {},
    criticalMax: 2000000,
  };

  const [state, setState] = useState(initialState);
  const [calculatorPayload, setCalCulatorPayload] = useState({});
  const [lang, setLang] = useState(props.lang);
  const [returnCalculatorAllData, setReturnCalculatorAllData] = useState(
    props.returnCalculator?.calculation
  );

  // =============
  const [dataLoop, setDataLoop] = useState([]);
  const [cumulativeTotal, setCumulativeTotal] = useState(0);
  const [total40, setTotal40] = useState(0);
  const [total50, setTotal50] = useState(0);
  const [maturityBenefit, setMaturityBenefit] = useState(0);
  // =============

  // Ref for DOM elements
  const policyRef = useRef();
  const termRef = useRef();
  const premiumRef = useRef();
  const genderRef = useRef();

  // Sync props to state (replace getDerivedStateFromProps functionality)
  useEffect(() => {
    setLang(props.lang);
    setState((prevState) => ({
      ...prevState,
      returnCalculator: props.returnCalculator,
    }));
    // setState((prevState) => ({
    //   ...prevState,
    //   calculation: {
    //     ...props.returnCalculator?.calculation
    //   },
    // }));
  }, [props.lang, props.returnCalculator]);

  // Mimic componentDidUpdate on `state.calculation` changes
  useEffect(() => {
    console.log(
      "state.calculation 33333333333333333 & calculatorPayload",
      state.calculation,
      calculatorPayload
    );
    props.setReturnalCalculatorData({
      ...state.calculation,
      dateOf_birth: calculatorPayload?.dob,
    });
  }, [state.calculation]);

  const handleMessageClose = () => {
    setState((prevState) => ({
      ...prevState,
      message: "",
      message_type: "",
    }));
  };

  const handleDateChange = (date) => {
    setState((prevState) => ({
      ...prevState,
      startDate: date,
    }));
  };

  const handleSubmit = () => {
    const { styleinfo } = state;
    const userFormData = {
      dob: $("#dateofbirth").val(),
      policy_id: policyRef.current.value,
      term: styleinfo.licterm === "block" ? termRef.current.value : 0,
      premium: premiumRef.current.value,
      gender: styleinfo.gender === "block" ? genderRef.current.value : null,
    };
    console.log("userFormdata 3433", userFormData);
    setCalCulatorPayload(userFormData);

    const resetValidator = {
      dob: "",
      policy: "",
      term: "",
      premium: "",
      sum_assured: "",
      gender: "",
    };

    let validation = {};

    if (!userFormData.dob) {
      validation.dob = "This field is required.";
    }
    if (!userFormData.policy_id) {
      validation.policy = "This field is required.";
    }
    if (!userFormData.term && styleinfo.licterm === "block") {
      validation.term = "This field is required.";
    }
    if (!userFormData.premium && styleinfo.licterm === "block") {
      validation.premium = "This field is required.";
    }
    if (!userFormData.gender && styleinfo.gender === "block") {
      validation.gender = "This field is required.";
    }

    if (Object.keys(validation).length) {
      setState((prevState) => ({
        ...prevState,
        validator: { ...resetValidator, ...validation },
        message: "",
      }));
    } else {
      props.getReturnCalculations(userFormData).then((res) => {
        $("#dateofbirth").val("");

        let policy_name = "";
        console.log("res.plan.policy_id 222222222222", res?.plan, state.policy);
        for (let item in state.policy) {
          if (item === String(res.plan.policy_id)) {
            // Convert to string
            policy_name = state.policy[item];
          }
        }
        // let policy_name = policyRef.current.value;

        setState((prevState) => ({
          ...prevState,
          calculation: {
            ...res.plan,
            policy_name,
          },
          message: "",
          message_type: "success",
          validator: { ...resetValidator },
        }));
      });
    }
  };

  const handlePoliciesBasedOnAge = () => {
    const dob = $("#dateofbirth").val();
    if (dob) {
      props.getReturnPoliciesBasedOnAge({ dob }).then(({ policies }) => {
        setState((prevState) => ({
          ...prevState,
          policy: policies,
        }));
      });
    }
  };

  const handleTermsBasedOnPolicy = () => {
    const dob = $("#dateofbirth").val();
    const policy = policyRef.current.value;

    if (dob && policy) {
      props
        .getReturnTermsBasedOnPolicy({ dob, policy_id: policy })
        .then(({ terms }) => {
          setState((prevState) => ({
            ...prevState,
            terms,
          }));
        });
      handleOptionShowHide();
    }
  };

  const handlePremiumListBasedOnTerm = () => {
    const dob = $("#dateofbirth").val();
    const policy = policyRef.current.value;
    const term = termRef.current.value;

    if (dob && policy && term) {
      props
        .getReturnPremiumListBasedOnTerm({ dob, policy_id: policy, term })
        .then(({ premiums }) => {
          setState((prevState) => ({
            ...prevState,
            premiums,
          }));
        });
      handleOptionShowHide();
    }
  };

  const handleOptionShowHide = () => {
    const policy = policyRef.current.value;

    let conditionalData = {
      accidental: "block",
      licterm: "block",
      parentage: "none",
      critical: "none",
      critical_sum: "none",
      gender: "none",
    };

    switch (policy) {
      case "814":
        conditionalData.critical = "block";
        conditionalData.gender = "block";
        break;
      case "815":
        conditionalData.critical = "none";
        conditionalData.gender = "none";
        break;
      default:
        conditionalData.parentage = "none";
        conditionalData.licterm = "block";
    }

    setState((prevState) => ({
      ...prevState,
      styleinfo: {
        ...prevState.styleinfo,
        ...conditionalData,
      },
    }));
  };

  const {
    validator,
    policy,
    terms,
    premiums,
    styleinfo,
    calculation,
    message,
    message_type,
  } = state;
  const contents = props.data.content;

  console.log("333333333333333", returnCalculatorAllData, state.calculation);
  // ====================
  useEffect(() => {
    if (!calculation.policy_id) return;

    let newDataLoop = [];
    let newCumulativeTotal = 0;
    let newTotal40 = 0;
    let newTotal50 = 0;

    let calculatedMaturityBenefit =
      calculation.policy_id === 814
        ? calculation.sum_assured
        : calculation.sum_assured * 0.5;

    for (let i = 1; i <= parseInt(calculation.terms); i++) {
      newTotal40 += Math.ceil(calculation.sum_assured * 0.04);
      newTotal50 += Math.ceil(calculation.sum_assured * 0.05);

      newCumulativeTotal = calculation.premium_amount * 12 * i;
      newDataLoop.push(newCumulativeTotal);
    }

    setDataLoop(newDataLoop);
    setCumulativeTotal(newCumulativeTotal);
    setTotal40(newTotal40);
    setTotal50(newTotal50);
    setMaturityBenefit(calculatedMaturityBenefit);
  }, [calculation]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      calculation: {
        ...returnCalculatorAllData,
      },
    }));
  }, [returnCalculatorAllData]);


  return (
    <Fragment>
      <div className="contact-form">
        {lang === "en" && <h1>{contents ? contents.short_description : ""}</h1>}
        {lang === "bn" && (
          <h1>{contents ? contents.bn_short_description : ""}</h1>
        )}

        <div className="contact-main">
          {message && (
            <div
              className={`alert ${
                message_type === "success" ? "alert-success" : "alert-danger"
              }`}
            >
              {message}
              <button
                type="button"
                className="close"
                onClick={handleMessageClose}
              >
                &times;
              </button>
            </div>
          )}
          {/* Form fields */}
          <div className="row">
            <div className="col-md-7 col-sm-12">
              {" "}
              <form>
                {/* Date of Birth */}
                <div className="form-group">
                  <label>
                    <LangData keyname="label_premium_calculator_dob" />
                    <span>*</span>
                  </label>
                  <div>
                    {" "}
                    <DateInput
                      handlePoliciesBasedOnAge={handlePoliciesBasedOnAge}
                      id="dateofbirth"
                    />
                  </div>
                  {validator.dob && (
                    <span className="help-block form-text text-danger">
                      {validator.dob}
                    </span>
                  )}
                </div>

                {/* Policy */}
                <div className="form-group">
                  <label>
                    <LangData keyname="label_premium_calculator_plan_name" />
                    <span>*</span>
                  </label>
                  <select
                    ref={policyRef}
                    onChange={handleTermsBasedOnPolicy}
                    className="form-control"
                  >
                    <option value="">Select Policy</option>
                    {Object.entries(policy).map(([key, value]) => (
                      <option key={key} value={key}>
                        {value}
                      </option>
                    ))}
                  </select>
                  {validator.policy && (
                    <span className="help-block form-text text-danger">
                      {validator.policy}
                    </span>
                  )}
                </div>

                {/* Term */}
                <div
                  className="form-group"
                  style={{ display: styleinfo.licterm }}
                >
                  <label>
                    <LangData keyname="label_premium_calculator_term" />
                    <span>*</span>
                  </label>
                  <select
                    ref={termRef}
                    onChange={handlePremiumListBasedOnTerm}
                    className="form-control"
                  >
                    <option value="">Select Term</option>
                    {Object.entries(terms).map(([key, value]) => (
                      <option key={key} value={value}>
                        {value}
                      </option>
                    ))}
                  </select>
                  {validator.term && (
                    <span className="help-block form-text text-danger">
                      {validator.term}
                    </span>
                  )}
                </div>

                {/* Premium */}
                <div
                  className="form-group"
                  style={{ display: styleinfo.licterm }}
                >
                  <label>
                    <LangData keyname="label_return_calculator_premium" />
                    <span>*</span>
                  </label>
                  <select ref={premiumRef} className="form-control">
                    <option value="">Select Premium</option>
                    {Object.entries(premiums).map(([key, value]) => (
                      <option key={key} value={value}>
                        {value}
                      </option>
                    ))}
                  </select>
                  {validator.premium && (
                    <span className="help-block form-text text-danger">
                      {validator.premium}
                    </span>
                  )}
                </div>

                {/* Gender */}
                <div
                  className="form-group"
                  style={{ display: styleinfo.gender }}
                >
                  <label>
                    <LangData keyname="label_policy_holder_gender" />
                    <span>*</span>
                  </label>
                  <select ref={genderRef} className="form-control">
                    <option value="">Select</option>
                    <option value={1}>Male</option>
                    <option value={2}>Female</option>
                  </select>
                  {validator.gender && (
                    <span className="help-block form-text text-danger">
                      {validator.gender}
                    </span>
                  )}
                </div>

                {/* Submit */}
                <div className="submit">
                  <input
                    type="button"
                    value={lang === "bn" ? "ক্যালকুলেট" : "Calculate"}
                    className="btn submit-button"
                    onClick={handleSubmit}
                  />
                </div>
              </form>
            </div>
            <div className="col-md-5 col-sm-12">
              {" "}
              {calculation.policy_id && (
                <div className="calculated-result">
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Link
                      to={{ pathname: "/policy-buy" }}
                      className="btn btn-buynow policy-buy-btn"
                    >
                      Policy Buy Now
                    </Link>
                  </div>
                  <p>
                    <span className="label">
                      <LangData keyname="label_premium_calculator_plan_name" />:{" "}
                    </span>{" "}
                    {calculation.policy_name}
                  </p>
                  <p>
                    <span className="label">
                      {" "}
                      <LangData keyname="label_premium_calculator_customer_age" />
                      :
                    </span>{" "}
                    {calculation.age}
                  </p>
                  <p>
                    <span className="label">
                      <LangData keyname="label_premium_calculator_monthly_premium" />
                      :{" "}
                    </span>
                    {calculation.premium_amount}
                  </p>
                  <p>
                    <span className="label">
                      <LangData keyname="label_premium_calculator_term" />:
                    </span>{" "}
                    {calculation.terms}
                  </p>
                  <p>
                    <span className="label">
                      <LangData keyname="label_premium_calculator_mode" />:
                    </span>{" "}
                    Monthly
                  </p>
                  <p>
                    <span className="label">
                      <LangData keyname="label_premium_calculator_sum_assured" />
                      :
                    </span>{" "}
                    {calculation.sum_assured}
                  </p>

                  {calculation.gender /* && styleinfo.gender !== "none" */ && (
                    <p>
                      <span className="label">
                        <LangData keyname="label_policy_holder_gender" />:
                      </span>{" "}
                      {calculation.gender === 1 ? "Male" : "Female"}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* ======================= */}

          {/* ======================= */}
        </div>
      </div>
      {/* =========== */}
      {/* this for LIC Jibon Swapno */}
      {calculation.policy_id && (
        <div className="cumalative_data mt-4">
          <table className="table">
            <tr>
              <td>Year</td>
              <td>Monthly Premium Payable (Tk)</td>
              <td>Yearly Cumulative paid premium (Tk)</td>
              {policy.value === "815" && <td>Survival Benefit (Tk)</td>}
              <td>Payable on Death before Maturity date (Tk)</td>
              <td>Critical Illness Benefit (Tk)</td>
              <td>Maturity Benefit (Tk)</td>
              <td>Maturity payable if BDT 40 Bonus is declared (Tk)</td>
              <td>Maturity payable if BDT 50 Bonus is declared (Tk)</td>
            </tr>

            {dataLoop.length > 0 &&
              dataLoop.map((row, key) => (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>{calculation.premium_amount}</td>
                  <td>{row}</td>
                  {policy.value === "815" && key !== dataLoop.length && (
                    <td style={{ verticalAlign: "middle" }}>
                      {dataLoop.length / 3 === key + 1 ||
                      (dataLoop.length / 3) * 2 === key + 1
                        ? Math.ceil(calculation.sum_assured * 0.25)
                        : ""}
                    </td>
                  )}
                  {key === 0 && (
                    <td
                      rowSpan={dataLoop.length}
                      style={{ verticalAlign: "middle" }}
                    >
                      {Math.ceil(calculation.sum_assured)}+Bonus
                    </td>
                  )}
                  {key === 0 && (
                    <td
                      rowSpan={dataLoop.length}
                      style={{ verticalAlign: "middle" }}
                    >
                      {Math.round(calculation.sum_assured * 0.5)}
                    </td>
                  )}
                  {key === 0 && <td rowSpan={dataLoop.length}></td>}
                  <td>{Math.ceil(calculation.sum_assured * 0.04)}</td>
                  <td>{Math.ceil(calculation.sum_assured * 0.05)}</td>
                </tr>
              ))}
            <tr>
              <td colSpan={policy.value === "814" ? 4 : 5}>
                On maturity date at the end of {calculation.terms} year
              </td>
              <td>
                {Math.ceil(maturityBenefit)}
                +Bonus
              </td>
              <td>
                {Math.ceil(maturityBenefit)} + {Math.ceil(total40)}
                {" = "}
                {Math.ceil(maturityBenefit) + total40}
              </td>
              <td>
                {Math.ceil(maturityBenefit)} + {Math.ceil(total50)}
                {" = "}
                {Math.ceil(maturityBenefit) + Math.ceil(total50)}
              </td>
            </tr>
          </table>
        </div>
      )}
      {/* =========== */}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  lang: state.lang,
  returnCalculator: state.returnCalculator,
});

export default connect(mapStateToProps, {
  getReturnCalculations,
  getReturnPoliciesBasedOnAge,
  getReturnPremiumListBasedOnTerm,
  getReturnTermsBasedOnPolicy,
  setReturnalCalculatorData,
})(ReturncalCulatorform);
